"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeGet = require("@styled-system/theme-get");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BannerContainer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1m6rvr7-0"
})(["background-color:", ";padding:", "px;color:", ";display:inline-flex;position:fixed;z-index:999;bottom:0;right:0;left:0;font-size:16px;button{background-color:", ";color:", ";border:none;cursor:pointer;}"], (0, _pclnDesignSystem.getPaletteColor)('primary.light'), (0, _themeGet.themeGet)('space.4'), (0, _pclnDesignSystem.getPaletteColor)('primary.dark'), (0, _pclnDesignSystem.getPaletteColor)('primary.light'), (0, _pclnDesignSystem.getPaletteColor)('primary.dark'));

var BannerDesc = _styledComponents["default"].div.withConfig({
  componentId: "sc-1m6rvr7-1"
})(["padding-left:", "px;padding-right:", "px;"], (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('space.4'));

var GDPRBanner = (0, _react.memo)(function (_ref) {
  var show = _ref.show,
      termsURL = _ref.termsURL,
      handleClose = _ref.handleClose;
  return show ? _react["default"].createElement(BannerContainer, null, _react["default"].createElement(_pclnDesignSystem.Icon, {
    name: "Information"
  }), _react["default"].createElement(BannerDesc, null, "We use cookies for technical, analytical and marketing purposes.", ' ', _react["default"].createElement(_pclnDesignSystem.Link, {
    href: termsURL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Here is more information"), ". Please proceed if this is okay with you."), _react["default"].createElement("button", {
    type: "button",
    onClick: handleClose
  }, _react["default"].createElement(_pclnDesignSystem.Icon, {
    name: "Close"
  }))) : null;
});
GDPRBanner.displayName = 'GDPRBanner';
GDPRBanner.defaultProps = {
  show: true
};
GDPRBanner.propTypes = {
  /**
   * Boolean to toggle showing and hiding the banner
   */
  show: _propTypes["default"].bool,

  /**
   * URL for the more information link
   */
  termsURL: _propTypes["default"].string.isRequired,

  /**
   * Function that is called upon closing the banner
   */
  handleClose: _propTypes["default"].func.isRequired
};
var _default = GDPRBanner;
exports["default"] = _default;